export const environment = {
  appVersion: require('../../package.json').version,
  production: false,
  homolog: false,
  DB_vendedores: 'app_martech_vendedores',
  DB_empresas: 'app_martech_marca',
  DB_clientes: 'app_martech_info_cliente',
  DB_ativacoes: 'ativacoes',
  DB_notas_clientes: 'app_martech_notas_clientes',
  DB_info_vendedores: 'app_martech_info_vendedores',
  DB_mrt_vendedores_crm: 'mrt_vendedor_crm',
  DB_lojas_deduplicadas: 'app-segmax-loja-deduplicada',
  eventos_URL: 'https://dbmax-eventos.web.app/evt/r',
  finishContact: 'https://us-east1-osklen.cloudfunctions.net/finish-contact-v2',
  cloudApi: {
    path: 'https://us-east1-osklen.cloudfunctions.net/new-direct-api',
    endpoints: {
      initialData: 'initial-data',
      finishContact: 'finish-contact',
    },
  },
  firebase: {
    apiKey: 'AIzaSyDKuvwqe_pWrYKTsWK7VhJG1JN1XsykTw8',
    authDomain: 'osklen.firebaseapp.com',
    databaseURL: 'https://osklen.firebaseio.com',
    projectId: 'osklen',
    storageBucket: 'osklen.appspot.com',
    messagingSenderId: '241169058925',
    appId: '1:241169058925:web:d78ad7689b7c6127290364',
  },
};
